import { IColors } from 'theme/types/palette';

export const colors: IColors = {
  primary: {
    main: '#000000', // Color/Gray/950 - Primary
    light: '#E5E4E2', // Light variant
    dark: '#000000', // Dark variant
    contrastText: '#FFFFFF', // Color/Gray/100 - Inverse Primary
  },

  secondary: {
    main: '#374151', // Color/Gray/700 - Secondary
    light: '#9CA3AF', // Color/Gray/400 - Inverse Secondary
    dark: '#4B5563', // Color/Gray/600 - Inverse Inactive
    contrastText: '#FFFFFF', // Contrast text
  },

  text: {
    primary: '#000000', // Color/Gray/950 - Primary text
    secondary: '#374151', // Color/Gray/700 - Secondary text
    disabled: '#E5E7EB', // Color/Gray/200 - Disable
    tertiary: '#4d5461', // Color/Gray/500 - Tertiary text
    muted: '#9ea2ae', // Color/Gray/400 - Muted / disabled labels
    emphasis: '#131313', // Near-black emphasis text
  },

  table: {
    main: '#000000', // Update with actual color
    light: '#E5E7EB', // Update with actual color
    dark: '#000000', // Update with actual color
    headerBackground: '#F3F5F7', // Figma table header
    contrastText: '#374151',
  },

  border: {
    main: '#E5E7EB', // Color/Gray/200 - Light border
    light: '#E5E7EB', // Color/Gray/200
    dark: '#374151', // Color/Gray/700
    contrastText: '#9CA3AF', // Color/Gray/400
  },

  background: {
    main: '#FFFFFF', // White background
    light: '#FFFFFF', // White
    dark: '#000000', // Color/Gray/950
    contrastText: '#E5E7EB', // Color/Gray/200
  },

  darkSection: {
    main: '#000000', // Color/Gray/950
    light: '#374151', // Color/Gray/700
    dark: '#FFFFFF', // Color/Gray/100
    contrastText: '#9CA3AF', // Color/Gray/400
  },

  button: {
    main: '#000000', // Color/Gray/950 - Primary button
    light: '#374151', // Color/Gray/700 - Secondary button
    dark: '#127A52', // Dark button
    contrastText: '#FFFFFF', // Color/Gray/100 - Button text
  },

  error: {
    main: '#d32f2f', // Error red
    light: '#ef5350', // Light error
    dark: '#c62828', // Dark error
    contrastText: '#FFFFFF',
  },

  success: {
    main: '#27BA10', // Success green
    light: '#E6F5E4', // Light success
    dark: '#1F8A14', // Dark success
    contrastText: '#FFFFFF',
  },

  basic: {
    main: '#F5F6F7', // Basic background
    light: '#FFFFFF', // Light basic
    dark: '#000000', // Dark basic
    contrastText: '#FDBB39', // Basic text
  },

  forward: {
    main: '#979797', // Forward color
    light: '#1D1D1D', // Light forward
    dark: '#E6F5ED', // Dark forward
    contrastText: '#E8E8E8', // Forward text
  },

  cards: {
    main: '#FFFFFF', // Card background
    light: '#F5F6F7', // Light card
    dark: '#000000', // Dark card
    contrastText: '#000000', // Card text
  },

  members: {
    main: '#FCFCFC', // Members background
    light: '#FCFCFC', // Light members
    dark: '#F2F2F2', // Dark members
    contrastText: '#000000', // Members text
  },

  role: {
    main: '#0CA4E0', // Role color
    light: '#27BA10', // Light role
    dark: '#BAEBFF', // Dark role
    contrastText: '#FFFFFF', // Role text
  },

  asset: {
    main: '#F6FFF5', // Asset background
    light: '#B5FFA9', // Light asset
    dark: '#BAEBFF', // Dark asset
    contrastText: '#000000', // Asset text
  },

  graph: {
    main: '#111827', // Graph background
    light: '#6B7280', // Light graph
    dark: '#061632', // Dark graph
    contrastText: '#E5F0EC', // Graph text
  },

  disable: {
    disable: '#E5E7EB', // Color/Gray/200 - Disable
  },
  signal: {
    main: '#12b76a', // Signal yellow
    light: '#F04438', // Light signal
    dark: '#F59E0B', // Dark signal
    contrastText: '#131314', // Signal text
  },
  scrollbar: {
    main: '#727883', // Scrollbar background
    light: '#E5E7EB', // Light scrollbar
    dark: '#FEE3AE', // Dark scrollbar
    contrastText: '#E9EAEB', // Scrollbar text
  },
  tabsXL: {
    main: '#D2D5DB',
    light: 'choose colors',
    dark: 'choose colors',
    contrastText: 'choose colors',
  },
  subtle: {
    main: '#E0FAF0', // Subtle background
    light: '#F5F6F7', // Light subtle
    dark: '#F9FAFB', // Dark subtle
    contrastText: '#000000', // Subtle text
  },
  landing: {
    main: '#127A52',
    light: '#FFFEF6',
    dark: '#084239',
    contrastText: '#1E0E62',
  },
  payoutSetup: {
    pageBackground: '#f3f5f7',
    stepBorder: '#d2d5db',
    stepSurface: '#ffffff',
    title: '#131313',
    stepTitle: '#131313',
    description: '#4d5461',
    stepLocked: '#9ea2ae',
    remainingText: '#9ea2ae',
    infoSheetBackground: '#fffef7',
    infoSheetCta: '#387855',
    infoSheetTitle: '#9a6908',
  },
};

export default colors;
